import { useMemo } from 'react';
import { IdentityTaskDto, IdentityTaskStatus } from '../../api/app.types';
import { useFilterContext } from './filter-context';

export function useFilteredTasks(tasks: undefined): undefined;

export function useFilteredTasks(tasks: IdentityTaskDto[]): IdentityTaskDto[];

export function useFilteredTasks(tasks: IdentityTaskDto[] | undefined): IdentityTaskDto[] | undefined;

export function useFilteredTasks(tasks: IdentityTaskDto[] | undefined) {
  const { hideClosedTasks } = useFilterContext();

  return useMemo(() => {
    if (!tasks) return undefined;

    return hideClosedTasks ? tasks.filter((task) => task.status !== IdentityTaskStatus.Done) : tasks;
  }, [tasks, hideClosedTasks]);
}
